import React from "react";
import {Modal} from 'antd';
import getSize from "../../../../utils/getSize";
import NHFetch from "../../../../utils/NHFetch";
import css from './index.css';
import JxShypcx from "../jxShypcx";//基线
import ScjtShypcx from "../scjtShypcx";//四川交通

const confirm = Modal.confirm;

const baseUrlPath = "/swbl/lstd"; //基础路径
/**
 * 生活用品查询列表
 * @author liudongbin
 * @date 2021年7月29日 19点36分
 * Version: 1.0
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["shypcx"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "scjt") {
                          return <ScjtShypcx/>
                      } else {
                          return <JxShypcx/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxShypcx/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/tjcx/shypcx/tyShypxc/index.js